import {
  ProgrammeDeliveryModeEnum,
  ModuleResultModeEnum,
  ProgressionTypeEnum,
  OutstandingModeEnum,
  CompulsoryModeEnum,
} from '@/types/composition-functions';

export interface DegreeOption {
  label: string;
  value: string;
}

export interface CalculationMethodOption {
  label: string;
  value: string;
}

export const CALCULATION_METHOD_OPTIONS: CalculationMethodOption[] = [
  { label: 'CGPA', value: 'cgpa' },
  { label: 'Weighted', value: 'weighted' },
];

export interface DeliveryModeOption {
  label: string;
  value: ProgrammeDeliveryModeEnum;
}

export interface ModuleResultModeOption {
  label: string;
  value: ModuleResultModeEnum;
}

export const DELIVERY_MODE_OPTIONS: DeliveryModeOption[] = [
  { label: 'Regular (semester-based)', value: ProgrammeDeliveryModeEnum.Regular },
  { label: 'Modular (sequential course blocks)', value: ProgrammeDeliveryModeEnum.Modular },
  { label: 'Residence (residency blocks)', value: ProgrammeDeliveryModeEnum.Residence },
];

export const MODULE_RESULT_MODE_OPTIONS: ModuleResultModeOption[] = [
  { label: 'Roll up into semester result', value: ModuleResultModeEnum.Rollup },
  { label: 'Separate result per module', value: ModuleResultModeEnum.Separate },
];

export interface ProgressionTypeOption {
  label: string;
  value: ProgressionTypeEnum;
}

export const PROGRESSION_TYPE_OPTIONS: ProgressionTypeOption[] = [
  { label: 'Level-based (default)', value: ProgressionTypeEnum.Level },
  { label: 'Year-based (postgrad)', value: ProgressionTypeEnum.Year },
];

export interface OutstandingModeOption {
  label: string;
  value: OutstandingModeEnum;
}

export const OUTSTANDING_MODE_OPTIONS: OutstandingModeOption[] = [
  { label: 'Matching semester only (default)', value: OutstandingModeEnum.SemesterMatch },
  { label: 'All semesters', value: OutstandingModeEnum.AllSemesters },
  { label: 'All semesters + same level', value: OutstandingModeEnum.AllInclusive },
];

export interface CompulsoryModeOption {
  label: string;
  value: CompulsoryModeEnum;
}

export const COMPULSORY_MODE_OPTIONS: CompulsoryModeOption[] = [
  { label: 'Enforced (default)', value: CompulsoryModeEnum.Enforced },
  { label: 'Flexible (student can choose)', value: CompulsoryModeEnum.Flexible },
];

export const POSTGRAD_DEGREES = new Set([
  'PGD', 'LLM', 'MA', 'MBA', 'MMP', 'MPHIL', 'MSC', 'MPHIL-PHD', 'PHD',
]);

export const DEGREE_OPTIONS: DegreeOption[] = [
  // Pre-degree / foundation
  { label: 'A-LEVEL', value: 'A-LEVEL' },
  { label: 'JUPEB', value: 'JUPEB' },
  { label: 'IGMB', value: 'IGMB' },

  // Certificates & diplomas
  { label: 'CERT', value: 'CERT' },
  { label: 'DIP', value: 'DIP' },
  { label: 'ADV-DIP', value: 'ADV-DIP' },
  { label: 'ND', value: 'ND' },
  { label: 'OND', value: 'OND' },
  { label: 'HND', value: 'HND' },
  { label: 'PGD', value: 'PGD' },

  // Bachelor's
  { label: 'BA', value: 'BA' },
  { label: 'BSC', value: 'BSC' },

  // Master's
  { label: 'LLM', value: 'LLM' },
  { label: 'MA', value: 'MA' },
  { label: 'MBA', value: 'MBA' },
  { label: 'MMP', value: 'MMP' },
  { label: 'MPHIL', value: 'MPHIL' },
  { label: 'MSC', value: 'MSC' },

  // Doctoral
  { label: 'MPHIL-PHD', value: 'MPHIL-PHD' },
  { label: 'PHD', value: 'PHD' },
];
